import { Role } from './Role';

export enum UserStatus {
    Active = 'Aktivan',
    Blocked = 'Neaktivan',
}

export interface User {
    id?: string;
    nameAndSurname: string;
    role: Role;
    phone?: string;
    email: string;
    password: string;
    status?: UserStatus;
    accessToken?: string;
    tokenExpiration?: number;
}
